export enum PhoneNumberError {
    PHONE_NUMBER_IS_TOO_SHORT,
    PHONE_NUMBER_IS_TOO_LONG,
}